import { gql, TypedDocumentNode } from "@apollo/client";

import {
  SendClientSummaryEmailMutation,
  SendClientSummaryEmailMutationVariables,
} from "./SendClientSummaryEmail.generated";

const SEND_CLIENT_SUMMARY_EMAIL: TypedDocumentNode<
  SendClientSummaryEmailMutation,
  SendClientSummaryEmailMutationVariables
> = gql`
  mutation sendClientSummaryEmail(
    $toEmail: String
    $clientSummary: String
  ) {
    sendClientSummaryEmail(
      toEmail: $toEmail
      clientSummary: $clientSummary
    ) {
      ok
    }
  }
`;

export default SEND_CLIENT_SUMMARY_EMAIL;
